module.exports = __webpack_public_path__ + "static/media/background01.02b9de1e.jpg";